// extracted by mini-css-extract-plugin
module.exports = {"legalPolicies":"LegalPolicies_legalPolicies__DjhHr","hidden":"LegalPolicies_hidden__CkC7l"};